import { useCommonStore } from 'state/store/common/useCommonStore';
import { canEditResource, isOwner, resolveCreatedBy, type OwnedResource } from 'lib/ownership';

/**
 * Returns true when the logged-in user may edit the resource.
 * Pass the resource object to honour the server `can_edit` / `canEdit` / `CanEdit`
 * flag (which also grants org admins write access); it falls back to comparing
 * `createdBy` / `created_by` when the flag is absent. Passing a bare createdBy
 * id string only ever compares ids.
 *
 * @example
 * const canEdit = useIsOwner(agent);
 * <Button disabled={!canEdit} onClick={onEdit}>Save</Button>
 */
export function useIsOwner(
  createdByOrResource?: string | null | OwnedResource
): boolean {
  const userId = useCommonStore((state) => state.user?.id);
  if (typeof createdByOrResource === 'string') {
    return isOwner(resolveCreatedBy(createdByOrResource), userId);
  }
  return canEditResource(createdByOrResource, userId);
}
